import { queries } from "../../shared/queries";
import { useQuery } from "@rocicorp/zero/react";

export function useTenantCustomDomain(): string | null {
  const [domains] = useQuery(queries.tenantCustomDomains());
  return domains?.[0]?.domain ?? null;
}
